export default class FieldValidator {
    message;
    constructor(message) {
        this.message = message;
    }

    async validate(value) {
    }
}